import { type FC } from 'react';

import { Box } from '../Box';
import { Text } from '../Typography';
import { type FeatureListItemProps, FeatureListItem } from './components';

export type FeatureItem = Omit<FeatureListItemProps, 'className'>;

export type FeatureListSection = {
  /**
   * Optional heading for this feature list section
   */
  heading?: string;
  /**
   * Array of feature items for this section
   */
  items: FeatureItem[];
};

export type FeatureListProps = FeatureListSection & {
  /**
   * Additional CSS class names
   */
  className?: string;
};

const FeatureList: FC<FeatureListProps> = ({ heading, items, className }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="var(--spacing-2)"
      className={className}
    >
      {heading && <Text fontWeight="bold">{heading}</Text>}

      <Box display="flex" flexDirection="column" gap="var(--spacing-2)">
        {items.map((item, index) => (
          <FeatureListItem key={`${item.iconVariant}-${index}`} {...item} />
        ))}
      </Box>
    </Box>
  );
};

export default FeatureList;
